const TOKEN_EXPIRED_PHRASE = 'token has expired';

let hasPatchedFetch = false;
let isRedirectInProgress = false;

const clearAuthStorage = () => {
  const keysToClear = [
    'token',
    'role',
    'loggedInUser',
    'hospitalId',
    'hospitalLogo',
    'userId',
    'is_first_login',
    'hospitalName',
    'adminSelectedUser',
  ];

  keysToClear.forEach((key) => localStorage.removeItem(key));
};

const getResponseMessage = async (response) => {
  try {
    const contentType = response.headers.get('content-type') || '';
    const clonedResponse = response.clone();

    if (contentType.toLowerCase().includes('application/json')) {
      const data = await clonedResponse.json();
      if (typeof data?.msg === 'string') {
        return data.msg;
      }

      return '';
    }

    const text = await clonedResponse.text();
    return typeof text === 'string' ? text : '';
  } catch (error) {
    return '';
  }
};

const handleTokenExpired = () => {
  if (isRedirectInProgress) {
    return;
  }

  isRedirectInProgress = true;
  clearAuthStorage();
  window.dispatchEvent(new Event('storage'));
//   window.alert('Token is expired. Please login again.');
  window.location.replace('/login');
};

export const setupAuthRedirectOnTokenExpiry = () => {
  if (hasPatchedFetch || typeof window.fetch !== 'function') {
    return;
  }

  hasPatchedFetch = true;
  const originalFetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    if (response.status === 401) {
      const message = await getResponseMessage(response);
      if (message.toLowerCase().includes(TOKEN_EXPIRED_PHRASE)) {
        handleTokenExpired();
      }
    }

    return response;
  };
};
